import type { ViewerDataSource } from '@genesisframeworks/viewer-plugin';
import { AuthenticatedBoxDataSource } from './ownerDataSource';
import { PublicShareDataSource } from './publicDataSource';

export type ViewerAuth =
  | { kind: 'owner' }
  | { kind: 'public'; shareId: string };

export interface CreateDataSourceOptions {
  auth: ViewerAuth;
  folderPath?: string;
  filePath?: string;
}

export function createDataSource(options: CreateDataSourceOptions): ViewerDataSource {
  if (options.auth.kind === 'owner') {
    if (options.folderPath === undefined) throw new Error('AuthenticatedBoxDataSource requires folderPath');
    return new AuthenticatedBoxDataSource({
      folderPath: options.folderPath,
      filePath: options.filePath,
    });
  }
  return new PublicShareDataSource({ shareId: options.auth.shareId });
}

export { AuthenticatedBoxDataSource, ownerDataSource } from './ownerDataSource';
export { PublicShareDataSource, publicDataSource } from './publicDataSource';
